import React, { FC, useMemo } from "react";
import { useIntl } from "react-intl";
import Typography from "../../Unknown/Typography";
import useTranslations from "./useTranslations";
import Box from "../../Unknown/Box";
import Button from "../../Unknown/Button";
import Grid from "../../Unknown/Grid";
import useStyles from "./useStyles";
import { ConfirmedAppointment } from "../AppointmentConfirmedScreen/parseConfirmedAppointment";

type UpsellSummaryProps = {
  isConfirmationLoading: boolean;
  summaryPrice: number;
  appointmentData: ConfirmedAppointment;
  onConfirm: () => Promise<void>;
};

const UpsellSummary: FC<UpsellSummaryProps> = ({
  isConfirmationLoading,
  summaryPrice,
  appointmentData,
  onConfirm,
}) => {
  const {
    translations: { summaryTitle, chargeNotification, confirmChangesLabel },
  } = useTranslations();

  const { formatNumber } = useIntl();

  const { summaryRoot } = useStyles();

  const formattedPrice = useMemo(() => {
    return formatNumber(summaryPrice, {
      style: "currency",
      currency: appointmentData.center.defaultCurrencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }, [formatNumber, summaryPrice, appointmentData.center.defaultCurrencyCode]);

  return (
    <Grid item xs={12} mt={2}>
      <Box
        className={summaryRoot}
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={{ md: "flex-end" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        gap={{ xs: 4, md: 8 }}
      >
        <Box display="flex" flexDirection="column">
          <Typography fontWeight={700}>
            {summaryTitle} {formattedPrice}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {chargeNotification}
          </Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={onConfirm}
            isLoading={isConfirmationLoading}
            disabled={isConfirmationLoading}
          >
            {confirmChangesLabel}
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default UpsellSummary;
